import React from 'react';
import {VideoEditorText} from '../VideoEditorText';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
// import {ReactComponent as EditScriptIcon} from '../../../assets/images/sound-file-icon.svg';
// import {ReactComponent as MuteAudioIcon} from '../../../assets/images/mute-icon.svg';
import {ReactComponent as RegenerateIcon} from '../../../assets/images/regenerate-icon.svg';
import {ReactComponent as ChangeMediaIcon} from '../../../assets/images/changeMedia.svg';
import {ReactComponent as DeleteIcon} from '../../../assets/images/trash-icon.svg';
import {ReactComponent as EditIcon} from '../../../assets/images/edit.svg';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import styles from './EditChunkOptions.module.css';
import {ReactComponent as Dots} from '../../../assets/images/dots-horizontal.svg';
import ContextMenuProviderStore from '../../../modules/ContextMenuProvider/store/ContextMenuProviderStore';
import {inject} from 'mobx-react';
import {appText} from '../../../assets/text/appText';
import ConfirmationModal from '../../../uiToolkit/ConfirmationModal';
import featureFlags, {FeatureFlagName} from '../../../utils/featureFlags';

interface Props {
  chunk: GeneratedVideoChunk;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  contextMenuProviderStore?: ContextMenuProviderStore;
  isTiny: boolean;
}

const EditChunkOptions = inject('contextMenuProviderStore')(
  React.memo(
    ({chunk, onEditChunk, contextMenuProviderStore, isTiny}: Props) => {
      const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);

      // const onEditScriptOption = () => {
      //   contextMenuProviderStore?.close();
      //   onEditChunk(EditChunkOption.EditScript, chunk.id);
      //   contextMenuProviderStore?.close();
      // };
      // const onMuteAudioOption = () => {
      //   contextMenuProviderStore?.close();
      //   onEditChunk(EditChunkOption.MuteAudio, chunk.id);
      //   contextMenuProviderStore?.close();
      // };
      const onRegenerateOption = () => {
        contextMenuProviderStore?.close();
        onEditChunk(EditChunkOption.Regenerate, chunk.id);
        contextMenuProviderStore?.close();
      };

      const onChangeFromLibraryOption = () => {
        onEditChunk(EditChunkOption.ChangeFromLibrary, chunk.id);
        contextMenuProviderStore?.close();
      };

      const onChangeMediaOption = () => {
        onEditChunk(EditChunkOption.ChangeMedia, chunk.id);
        contextMenuProviderStore?.close();
      };
      const onDeleteOption = () => {
        onEditChunk(EditChunkOption.Delete, chunk.id);
        contextMenuProviderStore?.close();
      };

      const onEditNarrationOption = () => {
        onEditChunk(EditChunkOption.EditNarration, chunk.id);
        contextMenuProviderStore?.close();
      };

      const EditOption = ({
        onClick,
        icon: Icon,
        label,
        disabled = false,
        extraClass = '',
      }: {
        onClick: () => void;
        icon: React.ElementType;
        label: string;
        disabled?: boolean;
        extraClass?: string;
      }) => {
        return (
          <div
            className={`${styles.option} ${extraClass} ${
              disabled ? styles.disabled : ''
            }`}
            onClick={!disabled ? onClick : undefined}
            role="button"
            aria-disabled={disabled}>
            <Icon className={styles.editVideoOptionIcon} />
            {label}
          </div>
        );
      };

      const openOptions = (e: React.MouseEvent) => {
        contextMenuProviderStore?.show(
          <div className={styles.options}>
            {/* <EditOption
              onClick={onEditScriptOption}
              icon={EditScriptIcon}
              label={VideoEditorText.editVideoOptions_EditScript}
            /> */}
            {/* <EditOption
              onClick={onMuteAudioOption}
              icon={MuteAudioIcon}
              label={VideoEditorText.editVideoOptions_MuteAudio}
              disabled={!chunk.audioUri}
            /> */}
            <EditOption
              onClick={onRegenerateOption}
              icon={RegenerateIcon}
              label={VideoEditorText.editVideoOptions_Regenerate}
              disabled={chunk.notSupportedToRegenerate}
            />
            <EditOption
              onClick={onChangeMediaOption}
              icon={ChangeMediaIcon}
              label={VideoEditorText.editVideoOptions_ChangeMedia}
              disabled={chunk.notSupportedForStoryblocks}
            />
            <EditOption
              onClick={onChangeFromLibraryOption}
              icon={ChangeMediaIcon}
              label={VideoEditorText.editVideoOptions_ChangeMediaLibrary}
              disabled={chunk.notSupportedForStoryblocks}
            />
            {featureFlags.get(FeatureFlagName.EditNarration) && (
              <EditOption
                onClick={onEditNarrationOption}
                icon={EditIcon}
                label={VideoEditorText.editVideoOptions_EditNarration}
              />
            )}
            <EditOption
              onClick={showModal}
              icon={DeleteIcon}
              label={VideoEditorText.editVideoOptions_Delete}
              extraClass={styles.deleteOption}
            />
          </div>,
          {x: e.clientX, y: e.clientY + 25},
        );
      };

      const showModal = () => {
        setShowConfirmDelete(true);
        contextMenuProviderStore?.close();
      };
      const cancelModal = () => {
        setShowConfirmDelete(false);
        contextMenuProviderStore?.close();
      };

      return (
        <div
          className={`${styles.editChunkOptions} ${
            isTiny ? styles.tinyChunk : ''
          }`}>
          <button className={styles.opener} onClick={openOptions}>
            <Dots />
          </button>

          <ConfirmationModal
            title={VideoEditorText.editVideoOptions_ConfirmDelete}
            onAccept={onDeleteOption}
            onCancel={cancelModal}
            shown={showConfirmDelete}
            acceptText={appText.delete}
          />
        </div>
      );
    },
  ),
);

export default EditChunkOptions;
